import that from '../utilities/translationHelper'

const weatherTypes = {
	weatherSunny: {
		type: 'weatherSunny',
		name: that.context.translate('Sunny')
	},
	weatherWindy: {
		type: 'weatherWindy',
		name: that.context.translate('Windy')
	},
	weatherCloudy: {
		type: 'weatherCloudy',
		name: that.context.translate('Cloudy')
	},
	weatherRainy: {
		type: 'weatherRainy',
		name: that.context.translate('Rainy')
	},
	weatherStormy: {
		type: 'weatherStormy',
		name: that.context.translate('Stormy')
	},
	weatherSnowy: {
		type: 'weatherSnowy',
		name: that.context.translate('Snowy')
	},
	weatherPartCloudy: {
		type: 'weatherPartCloudy',
		name: that.context.translate('Part cloudy')
	},
	weatherNight: {
		type: 'weatherNight',
		name: that.context.translate('Clear night')
	}
}

export default weatherTypes



// WEBPACK FOOTER //
// ./src/enums/weatherTypes.js